import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {SalesScope} from '../../model/sales-scope';

export type SalesState = {
  currentScope: SalesScope
};

const initialState: SalesState = {
  currentScope: SalesScope.SEARCH
};

export const SalesSignalStore = signalStore(
  {providedIn: 'root'},
  withState(initialState),
  withMethods((store) => ({
    updateCurrentScope(scope: SalesScope): void {
      patchState(store, {currentScope: scope});
    }
  }))
);
